export { App as default } from '@guiker/account-main-mfe'
